// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { CreditMethod } from '../../types/Model';

export interface BuyLabRequestPayload {
  id: number;
  test?: boolean;
  workshopId?: number;
  iltCourseId?: number;
  courseId?: number;
  creditMethod?: CreditMethod;
  success?: () => void;
  onError?: (error:string) => void;
}
export interface BuyLabSuccessPayload {}

export interface BuyLabFailPayload {
  error: Error;
}

export const buyLabActions = createAsyncAction(
  'elearning/BUY_LAB',
  'elearning/BUY_LAB_SUCCESS',
  'elearning/BUY_LAB_FAIL'
)<
  BuyLabRequestPayload,
  BuyLabSuccessPayload,
  BuyLabFailPayload
>();
